import { useContext, useState } from "react";
import BlockchainContext from "../store/BlockchainContext";

const AffiliateSection = () => {
  const [copied, setCopied] = useState(false);
  const {
    refWithdraw,
    getAvailableRefInfo,
    userInvitedInfo,
    usdPrice,
    account,
    userTotalDeposits,
  } = useContext(BlockchainContext);

  const handlecopy = () => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };
  return (
    <div className="video panel_section mt-5">
      <div className="container">
        <h2>Videos</h2>
        <div className="card panel">
          <div className="row">
            <div className="col-md-4 col-12">
              <iframe
                width="100%"
                height="300px"
                type="text/html"
                src="https://www.youtube.com/embed/I-Lwte_ZKvg?si=TxkX8K8W1eFVDTFK"
              ></iframe>
              <p className="mb-0 text-center">(Russian)</p>
            </div>

            <div className="col-md-4 col-12">
              <iframe
                frameBorder="0"
                scrolling="no"
                marginHeight="0"
                marginWidth="0"
                width="100%"
                height="300px"
                type="text/html"
                src="https://www.youtube.com/embed/uocUyYk9qVA?si=s6Ig84DivBeqSPnC"
              ></iframe>
              <p className="mb-0 text -center">(English)</p>
            </div>
            <div className="col-md-4 col-12">
              <iframe
                frameBorder="0"
                scrolling="no"
                marginHeight="0"
                marginWidth="0"
                width="100%"
                height="300px"
                type="text/html"
                src="https://www.youtube.com/embed/YzfG6eB25L8?si=8DNIsIhauz5GCavx"
              ></iframe>
              <p className="mb-0 text-center">(Turkish)</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AffiliateSection;
